module.exports = __webpack_public_path__ + "static/media/caravanId.31403338.png";